"use client";
import { component } from "@gnist/component-utils";
import { textContainer } from "@gnist/themes/atoms.css.js";
import { displayText, heading1Text, heading2Text, heading3Text, leadText, bodyText, linkText, detailText } from "./typography.css.js";
const tuple = (...args) => args;
const HeaderLevels = tuple(...["h1", "h2", "h3", "h4", "h5", "h6"]);
const TextContainer = component("TextContainer", textContainer, "div");
const DisplayText = component("DisplayText", displayText, "h1");
const Heading1Text = component("Heading1Text", heading1Text, "h2");
const Heading2Text = component("Heading2Text", heading2Text, "h3");
const Heading3Text = component("Heading3Text", heading3Text, "h4");
const LeadText = component("LeadText", leadText, "p");
const BodyText = component("BodyText", bodyText, "div");
const Link = component("Link", linkText, "a");
const DetailText = component("DetailText", detailText, "p");
export {
  BodyText,
  DetailText,
  DisplayText,
  HeaderLevels,
  Heading1Text,
  Heading2Text,
  Heading3Text,
  LeadText,
  Link,
  TextContainer
};
